export const getRemainingTime = (remainingTime?: string, language?: string): { formatted?: string; value?: number } => {
  if (remainingTime === undefined) {
    return {
      formatted: undefined,
      value: undefined,
    };
  }

  const remainingTimeInSeconds = Number(remainingTime);
  const hours = Math.floor(remainingTimeInSeconds / 3600);
  const minutes = Math.floor((remainingTimeInSeconds % 3600) / 60);

  const hourFormatter = new Intl.NumberFormat(language, { style: 'unit', unit: 'hour', unitDisplay: 'narrow' });
  const minuteFormatter = new Intl.NumberFormat(language, {
    style: 'unit',
    unit: 'minute',
    unitDisplay: 'short',
  });

  const parts = [];
  if (hours > 0) {
    parts.push(hourFormatter.format(hours));
  }
  if (minutes > 0) {
    parts.push(minuteFormatter.format(minutes));
  }

  const formatted = parts.length > 0 ? parts.join(' ') : minuteFormatter.format(0);

  return { formatted, value: remainingTimeInSeconds };
};
